import React from "react";
import image1 from "../../../Assets/Compliance Certifictes/image.png";
import image2 from "../../../Assets/Compliance Certifictes/image2.png";

const SAInfoContainer = () => {
  return (
    <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
      {/* left side */}
      <div className="w-full">
        {/* heading */}
        <div className="py-4 md:py-10">
          <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
            <h1 className="">
              <span className="border-b-4 border-[#249742]">GET </span>
              SA 8000 CERTIFICATION MUMBAI
            </h1>
          </div>
        </div>

        {/* content */}
        <div>
          <p className="font-normal text-lg text-[#4D4D4D]">
            SA 8000 is an international certification standard that encourages
            organizations to develop, maintain and apply socially acceptable
            practices in the workplace
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            By affixing the CE marking to a product, a manufacturer declares
            that the product meets all the legal requirements for CE marking and
            can be sold throughout the EEA. This also applies to products made
            in other countries that are sold in the EEA.
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            SA 8000 certification addresses issues including forced and child
            labor, occupational health and safety, freedom of association and
            collective bargaining, discrimination, disciplinary practices,
            working hours, compensation, and management systems
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Adopting SA 8000 certification means an organization must consider
            the social impact of their operations in addition to the conditions
            under which their employees, partners and suppliers operate. It can
            be applied to any company, of any size, worldwide
          </p>

          <p className="font-normal text-lg text-[#4D4D4D] py-2">
            Certifying your organization against SA 8000 will help you develop
            and improve social accountability across your operations.
          </p>
        </div>
      </div>

      {/* right side */}
      <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
        <div className="py-0 sm:py-8">
          <img
            src={image2}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>

        <div className="py-0 sm:py-8">
          <img
            src={image1}
            className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
            alt="Compliance certificate"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default SAInfoContainer;
